import { render, staticRenderFns } from "./CreateEditSupplier.vue?vue&type=template&id=1951977a"
import script from "./CreateEditSupplier.vue?vue&type=script&lang=js"
export * from "./CreateEditSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports